import "./accountCancelViewWizardStep3.scss";

import React from 'react';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import { i18n } from 'core/i18n';
const { FormattedText, formatText } = i18n;

import { OKMessage } from 'commonsComponents/OKMessage';
import SummaryList from "components/commons/summaryList/summaryList";
import SummaryListItem from "components/commons/summaryListItem/summaryListItem";
import { SignaturePattern } from 'components/signaturePattern/signaturePattern';

import { INTERVENER_TITLE } from "../../../../constants/interveners";
import {
    API_CENTER,
    API_ENTERPRISE_NUMBER,
} from 'constants/index';

const baseClassName = 'account-cancel-view-wizard-step3';

const buildIntervenerGroup = (immGroup) => {
    let type = immGroup.first().get('type');

    const interveners = immGroup.map(immIntervener => (
        <div className={`${baseClassName}__interveners-item`} key={immIntervener.get('name').toString()}>
            {immIntervener.get('name')}
        </div>
    ));

    const title = INTERVENER_TITLE[type];

    return (
        <div>
            <FormattedText className={`${baseClassName}__group-title`} value={title} />
            {interveners}
        </div>
    );
}

const buildInterveners = (interveners) => {
    return <div>
        <p className={`${baseClassName}__interveners-title`}><FormattedText value="contractsView-interveners" /></p>
        {interveners.groupBy(intervener => intervener.get('type')).map((intervenerGroup) => buildIntervenerGroup(intervenerGroup)).toArray()}
    </div>
}

function AccountCancelViewWizardStep3(props) {
    const { immAccount } = props;
    const originAccount =
    API_ENTERPRISE_NUMBER +
    API_CENTER +
    immAccount.get('product') +
    immAccount.get('contractNumber');
    const leftColumn = (
        <React.Fragment>
            <SummaryListItem text={formatText('profile-profileAliasLabel')} value={immAccount.get('alias')} />
            <SummaryListItem text={formatText('accountDetails-iban')} value={immAccount.get('iban')} />
        </React.Fragment>
    );
    const rightColumn = buildInterveners(immAccount.getIn(['interveners', 'list']));

    return <article className={baseClassName}>
        <section className={`${baseClassName}__summary`}>
            <h2 className={`${baseClassName}__title`}>
                <FormattedText value="cancellation_account-account_cancellation_request_step3_title" />
            </h2>
            <p className={`${baseClassName}__subtitle`}>
                <FormattedText value="cancellation_account-account_cancellation_request_step3_sub_title" />
            </p>
            <section className={`${baseClassName}__summary-data`}>
                <SummaryList rightColumn={rightColumn} leftColumn={leftColumn} />
            </section>
            <OKMessage type="important">
                <div className={`${baseClassName}__disclaimer-title`}>
                    <FormattedText value="transferSummary-step2WarningMessageTitle" />
                </div>
                <FormattedText value="cancellation_account-account_cancellation_request_step3_yellow_disclaimer_description" />
            </OKMessage>
        </section>
        <SignaturePattern
            operationType={266}
            operationParams={{
                originAccount: originAccount,
            }}
        />
    </article>
}

AccountCancelViewWizardStep3.propTypes = {
    immAccount: PropTypes.instanceOf(Immutable.Map).isRequired,
    immAccountCancel: PropTypes.instanceOf(Immutable.Map).isRequired,
};




export default AccountCancelViewWizardStep3;